function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 378",
  fill: "none",
  stroke: "#3c00dc"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 429",
  d: "M19.063.5H3.776A3.328 3.328 0 00.5 3.875v29.25A3.327 3.327 0 003.776 36.5h15.287a3.327 3.327 0 003.276-3.375V3.875A3.327 3.327 0 0019.063.5z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 377",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 430",
  d: "M11.375 33.875a2.25 2.25 0 01-2.25-2.25 2.25 2.25 0 012.25-2.25 2.25 2.25 0 012.25 2.25 2.247 2.247 0 01-2.246 2.25z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 431",
  d: "M19.25 26.284a.845.845 0 01-.844.844H4.344a.845.845 0 01-.844-.844V4.344a.845.845 0 01.844-.844H18.41a.845.845 0 01.844.844z"
})));

function SvgMobileinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.839,
    height: 37,
    viewBox: "0 0 22.839 37"
  }, props), _ref);
}

export default SvgMobileinline;